<template>
    <div class="container" id="blog_list">
        <div class="row">
            <div class="col col-lg-12">
                <h2 class="blog_title">Novinky</h2>
            </div>
        </div>
        <div class="row" v-if="posts">
            <div class="blog_item" v-for="item in posts.slice(0,3)" :key="item._id">
                <div class="row">
                    <div class="col col-lg-3 col-md-4 col-12">
                        <img v-if="item.image.path" v-bind:src="'http://www.clun-forest.sk/'+item.image.path" width="100%"/>
                        <img v-else v-bind:src="'/static/Images/stock.png'" width="100%"/>
                    </div>
                    <div class="col col-lg-9 col-md-8 col-12" >
                        <h3><router-link v-bind:to="'/blog_item/'+item._id">{{ item.title }}</router-link></h3>
                        <p class="custom_perex" v-html="item.text"></p>
                    </div>
                    <div class="col col-12">
                        <span>{{ item.date | formatDate }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div>Loading ...</div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col col-lg-4">
                <router-link class="custom_button invert" to="/blog">Zobraziť viac</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            posts: [],
            pictures: []
        }
    },

    // Fetches posts when the component is created.
    created() {
        var authOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            url: 'http://www.clun-forest.sk/cockpit/api/collections/get/news?token=715b9f9a9f192319672a7a842fc494',
            json: true
        };
        axios(authOptions)
        .then(response => {
            // JSON responses are automatically parsed.
            this.posts = response.data.entries.reverse();
            console.log(response.data.entries);  
        })
        .catch(e => {
            this.errors.push(e)
        })
    }
}
</script>
<style>
    @media (max-width: 767px) { 
        .blog_item .row .col:first-child {
            padding-bottom: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue